export default __webpack_public_path__ + "static/media/ba1.48e47a3e.jpg";